// extracted by mini-css-extract-plugin
module.exports = {"link":"catalog-menu_link__DjZGx","accent":"catalog-menu_accent__NDRzR","title":"catalog-menu_title__K7Zn_"};